
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateEventInvitationPublicDtoFormGroup() {
return new FormGroup({
    eventId: new FormControl<string | undefined>('', [Validators.required]),
    firstName: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    lastName: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    email: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(200)]),
    numberOfPersons: new FormControl<number | undefined>(undefined, [Validators.required, Validators.min(1), Validators.max(20)]),
    accepted: new FormControl<boolean | undefined>(true),
    encryptedContactId: new FormControl<string | undefined>(''),
    company: new FormControl<string | undefined>('', [Validators.maxLength(100)]),
})
;
}
      